import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import styled from 'styled-components';
import Button from 'components/UI/atoms/Button';
import TextField from 'components/UI/atoms/TextField';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';

export const MySwal = withReactContent(Swal);
registerLocale('ko', ko);

export const ButtonTag = styled(Button)`
  border: 1px solid #e2e2e2;
  padding: 5px 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  :hover {
    background: #0072ce;
  }
`;

export const ModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  height: 80vh;
  overflow: hidden;
`;

export const EditorSection = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  border-right: 1px solid #e2e2e2;
`;

export const PreviewSection = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  overflow-y: auto;
  padding: 20px;
  background: #f9f9f9;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  min-width: 650px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin-bottom: 10px;
`;

export const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 150px;
  padding: 10px;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  white-space: pre-wrap;
`;

export const ArrayItemContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
`;

export const SmallButton = styled(Button)`
  padding: 5px 10px;
  font-size: 12px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// 미리보기 전용 Styled Components (NoticeBox와 동일한 디자인)
export const PreviewContainer = styled.div`
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
  text-align: left;
  position: relative;
  padding: 30px;
  padding-top: 40px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e2e2e2;
  width: 600px !important;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const PreviewHeaderSection = styled.div`
  flex-shrink: 0;
`;

export const PreviewContentSection = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;

  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const PreviewFooterSection = styled.div`
  flex-shrink: 0;
  padding-top: 10px;
`;

export const PreviewTopRightBox = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  z-index: 10;
`;

export const PreviewCheckbox = styled.input`
  margin-right: 4px;
  transform: scale(1.1);
`;

export const PreviewLabel = styled.label`
  font-size: 13px;
  color: #555;
  cursor: default;
  user-select: none;
`;

export const PreviewTitle = styled.p`
  font-size: 28px;
  font-weight: 400;
  line-height: 40px;
  margin: 0 0 8px 0;
`;

export const PreviewSubtitle = styled(PreviewTitle)`
  font-size: 20px;
  margin-bottom: 16px;
`;

export const PreviewParagraph = styled.p`
  font-size: 14px;
  line-height: 2;
`;

export const PreviewHighlightBox = styled.div`
  background-color: #f1f7ff;
  color: #003173;
  line-height: 1.5;
  margin: 15px 0 16px;
  padding: 16px;
  border-radius: 6px;
  font-size: 14px;
`;

export const PreviewHighlightItem = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
`;

export const PreviewHighlightItemLabel = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

export const PreviewHighlightItemValue = styled.span`
  font-size: 14px;
`;

export const PreviewLink = styled.a`
  color: #2d8cff;
  text-decoration: underline;
  font-size: 14px;
`;

export const PreviewSpacer = styled.div`
  margin: 10px 0px;
  font-size: 14px;
`;
